
export default function Location() {
  return (
    <section id="찾아오시는 길" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">찾아오시는 길</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">유앤아이월드를 방문해주세요</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-lg h-[450px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.4!2d126.9516!3d37.5444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca25b26499999%3A0xdddddddddddddddd!2z6rO17Jqp7Jet!5e0!3m2!1sko!2skr!4v1640000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="공덕역 위치"
            ></iframe>
          </div>

          {/* Location Info */}
          <div className="flex flex-col justify-center">
            <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
                <i className="fas fa-map-marker-alt text-blue-600 mr-3 w-6 h-6 flex items-center justify-center"></i>
                오시는 길
              </h3>

              <div className="space-y-6">
                {/* Address */}
                <div className="flex items-start">
                  <div className="w-24 flex-shrink-0">
                    <span className="text-sm font-semibold text-gray-700">주소</span>
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-800">서울특별시 마포구 만리재로 14</p>
                    <p className="text-gray-800">한국사회복지회관 1507호</p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start">
                  <div className="w-24 flex-shrink-0">
                    <span className="text-sm font-semibold text-gray-700">전화</span>
                  </div>
                  <div className="flex-1">
                    <a href="tel:1600-9817" className="text-blue-600 hover:underline cursor-pointer">
                      1600-9817
                    </a>
                  </div>
                </div>

                {/* Fax */}
                <div className="flex items-start">
                  <div className="w-24 flex-shrink-0">
                    <span className="text-sm font-semibold text-gray-700">팩스</span>
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-800">02-6338-4404</p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start">
                  <div className="w-24 flex-shrink-0">
                    <span className="text-sm font-semibold text-gray-700">이메일</span>
                  </div>
                  <div className="flex-1">
                    <a href="mailto:uniworld1507@gmail.com" className="text-blue-600 hover:underline cursor-pointer">
                      uniworld1507@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
